import React, { useEffect, useRef, useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { UTILS_FUNCTION } from "../utils";
import { greenImageSize } from "../utils/constants";
import { saveCourseRotationSets } from "../utils/helpers";
import { useTranslation } from "react-i18next";

// CSS
import "./color-print.css";
import "./pin-placement.css";
const Canvas = React.memo(
  ({
    holeData,
    greensDescriptions,
    childFunc,
    measurementState,
    carPinPlacementStateData,
  }) => {
    useEffect(() => {
      childFunc.current = canvasSaveCourseRotationSets;
    }, []);
    const { siteSettingsData } =
      useSelector((state) => state.commonReducers) || [];
    const canvas = useRef();
    const svg = useRef();
    const { viewDistanceYardsReduxState, siteIdData } = useSelector(
      (state) => state.firstReducer
    );
    const { t } = useTranslation();
    // DO NOT REMOVE IT WILL BE USED IN FUTURE
    // Usefull Variables
    // let imageName =
    //   "apr0" +
    //   holeData?.Course +
    //   "-" +
    //   "0".concat(holeData?.Hole).slice(-2) +
    //   ".jpg";

    // let imagePath =
    //   `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetApproachImage?siteId=` +
    //   siteIdData +
    //   "&name=" +
    //   escape(imageName);

    let hole = {
      ...holeData,
      viewDistanceYards: viewDistanceYardsReduxState === 1 ? true : false,
    };

    // created compose function which compose Hole image URL
    function composeHoleUrl() {
      return `${
        process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetApproachImage?siteId=${siteIdData}&name=${escape(
        `apr0${holeData?.Course}-${`0`.concat(holeData?.Hole).slice(-2)}.jpg`
      )}`;
    }

    useEffect(() => {
      let imagePath = composeHoleUrl();
      const element = canvas && canvas.current.getContext("2d");
      const svgElement = svg && svg.current;
      UTILS_FUNCTION.createViewMatrices(greenImageSize, greenImageSize, hole);
      UTILS_FUNCTION.loadPicture(
        element,
        imagePath,
        greenImageSize,
        hole,
        element,
        greensDescriptions,
        siteSettingsData
      );
        UTILS_FUNCTION.createSvgElements(
          svgElement,
          hole,
          greensDescriptions,
          (carPinPlacementStateData?.Courses &&
          carPinPlacementStateData?.Courses?.length > 0) ?
          carPinPlacementStateData?.Courses.filter(
            (data) =>
              data.CourseNumber === parseInt(localStorage.getItem("courseId"))
          ) : ''
        );
    }, [siteIdData]);
   
    useEffect(() => {
        UTILS_FUNCTION.pinsEditButtonMode(hole);  
    }, [siteIdData]);

    const canvasSaveCourseRotationSets = useCallback(() => {
      saveCourseRotationSets();
    }, []);

    return (
      <li className="li">
        <div className="thumbnail">
          <div className="outsideWrapper">
            <div className="insideWrapper">
              <canvas
                ref={canvas}
                height={greenImageSize && greenImageSize}
                width={greenImageSize && greenImageSize}
                className="canvasstyle"
              ></canvas>
              <svg ref={svg} className="coveringCanvas pinsDisplay">
                <rect
                  id="unplacedPins"
                  x={250}
                  y={0}
                  width={50}
                  height={250}
                  fill="white"
                />
                <defs>
                  <marker
                    id="markerArrow"
                    markerWidth={13}
                    markerHeight={13}
                    refX={2}
                    refY={6}
                    orient="auto"
                  >
                    <path
                      d="M2,2 L2,11 L10,6 L2,2"
                      style={{ fill: "#000000" }}
                    />
                  </marker>
                </defs>
              </svg>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          {measurementState && (
            <>
              <h4 className="pull-left" style={{ fontWeight: "normal" }}>
                <span className="xl">{t("Depth")}</span>{" "}
                <span id={`holeDepth_${holeData?.Hole}`}></span>
              </h4>
              <h4 className="pull-right" style={{ fontWeight: "normal" }}>
                <span className="xl">{t("Width")}</span>{" "}
                <span id={`holeWidth_${holeData?.Hole}`}></span>
              </h4>
            </>
          )}
        </div>
      </li>
    );
  }
);

export default Canvas;
